import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button
} from "@chakra-ui/react";

const CompletionMarkModal = ({ isOpen, onClose, handleTicketCompletion, selectedTicket }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Povrda odrađenosti</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {selectedTicket ? (
                        <>Želite li označiti zadatak "<strong>{selectedTicket.name} kao odrađen?</strong>"?</>
                    ) : (
                        <>Učitavanje detalja zadatka...</>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" onClick={handleTicketCompletion} isDisabled={!selectedTicket}>Označi</Button>
                    <Button variant="ghost" onClick={onClose}>Povratak</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default CompletionMarkModal;